module.exports = __webpack_public_path__ + "static/media/empty.09f35886.svg";